export default __webpack_public_path__ + "static/media/wing-right.0ed52114.png";